import { useMemo } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useRetailerSettings } from '../useRetailerSettings';

import { useFetchSinksQuery } from '~/api/easy-estimator-api/sinks-api/sinksService';
import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { useStores } from '~/api/easy-estimator-api/stores-api/useStores';
import { ApplianceSource, ApplianceType } from '~/core/models';
import { emptyArray, makeSinksSelector } from '~/core/utils';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { selectZipcode } from '~/redux/slices/zipcode';

export const useFetchSinks = () => {
  const zipcode = useAppSelector(selectZipcode);
  const selectedColor = useAppSelector(selectSelectedColor);

  const { stores } = useStores();
  const selectedStore = useSelectedStore();
  const { retailerSettings } = useRetailerSettings();

  const selectSinksTransformed = useMemo(() => makeSinksSelector(), []);

  const {
    programSinks,
    isFetching: isFetchingSinks,
    isError: isErrorSinks,
  } = useFetchSinksQuery(
    !zipcode || !selectedColor || !stores.length
      ? skipToken
      : {
          params: {
            zipCode: zipcode,
            storeId:
              (retailerSettings?.showStores
                ? selectedStore?.companyId
                : null) ?? undefined,
            ...(selectedColor?.qteGrpID
              ? { prodQteGrpID: selectedColor.qteGrpID }
              : {}),
          },
        },
    {
      selectFromResult: ({ data, ...rest }) => ({
        programSinks: rest.isError
          ? emptyArray
          : selectSinksTransformed(
              data ?? emptyArray,
              ApplianceSource.PROGRAM,
              ApplianceType.SINK,
              true
            ),
        ...rest,
      }),
    }
  );

  return {
    programSinks,
    isFetchingSinks,
    isErrorSinks,
  };
};
